import axiosMapInstance from "../interceptor/webMapInstance";
import { getQueryParams, capacityURL } from "./capacityService";

const supplyBaseUrl = `${process.env.REACT_APP_BASE_URL_WEB_MAP}/supply`;
const demandBaseUrl = `${process.env.REACT_APP_BASE_URL_WEB_MAP}/demand`;

export const getBestOperatorGeohashes = async (data, cancelToken, pageSize, page) => {
  const requestBody = {
    quarter: `${data.quarter} ${data.year}`,
    connectionType: data.ct,
    dataType: data.dt,
    aggrType: data.at,
    northEast: data.northEast,
    southWest: data.southWest,
    isDownloadEnabled: data.isDownloadEnabled,
    coordinates:data.coordinates,
    radius:data.radius,
    limit: pageSize,
    page: page,
  };

  const response = await axiosMapInstance.post(
    `${supplyBaseUrl}/best/${data.countryCode}${data.level ? "/" + data.level + "/" + data.levelVal : ""}`,
    requestBody,
    { cancelToken: cancelToken?.token, clearCacheEntry: true }
  );
  return response.data;
};


export const getBestOperatorTooltipData = async (
  { country, geohash, quarter, ct, dt, at }
) => {
  const response = await axiosMapInstance.get(
    `${supplyBaseUrl}/tooltip/best/${country}/${geohash}?quarter=${quarter}&connectionType=${ct}&dataType=${dt}${at ? "&aggrType="+at : ""}`,
    { clearCacheEntry: true }
  );
  return response.data;
};

export const getCustomOperatorGeohashes = async (
  {
    countryCode,
    level,
    levelVal,
    quarter,
    year,
    operator,
    filter,
    type,
    northEast,
    southWest,
    ct,
    dt,
    at,
    action,
    quad,
    isDownloadEnabled,
    coordinates,
    radius,
  },
  cancelToken,
  pageSize,
  page
) => {
  const requestBody = {
    quarter: `${quarter} ${year}`,
    operator,
    filter,
    type,
    northEast,
    southWest,
    connectionType: ct,
    dataType: dt,
    aggrType: at,
    action,
    quad,
    isDownloadEnabled,
    coordinates,
    radius,
    limit: pageSize,
    page,
  };
  const response = await axiosMapInstance.post(
    `${supplyBaseUrl}/level/${countryCode}${
      level ? "/" + level + "/" + levelVal : ""
    }`,
    requestBody,
    { cancelToken: cancelToken?.token, clearCacheEntry: true }
  );
  return response.data;
};

export const getOperatorTooltipData = async (
  data, isMS = false
) => {
  const response = await axiosMapInstance.get(
    `${supplyBaseUrl}/tooltip/level/${data.country}/${data.geohash}`,
    {
      params: {
        quarter: data.quarter,
        connectionType: data.ct,
        dataType: data.dt,
        aggrType: data.at,
        ...(isMS && {
          operator: data.operator,
          adminLevel1: data.adminLevel1,
          adminLevel2: data.adminLevel2,
          adminLevel3: data.adminLevel3
        })
      }
    },
    { clearCacheEntry: true }
  );
  return response.data;
};

// get min and max for Supply Custom (Data Received, Data Transmit and Data Transceived)
export const fetchMinMaxSupplyOp = async (data)=> {
  const params = {
    quarter: data.quarter,
    ct: data.ct,
    dt: data.dt,
    st: data.st,
  }
  if (data.op) params.op = data.op;
  const response = await axiosMapInstance.get(
    `${supplyBaseUrl}/operator/legend/minMax${data.country}`,
    {
      params,
      hideLoader: true
    }
  );
  return response.data;
};

export const getDemandFinalScoreGeohashes = async (
  { countryCode, level, levelVal, quarter, year, northEast, southWest, isDownloadEnabled, coordinates, radius },
  cancelToken,
  pageSize,
  page
) => {
  const requestBody = {
    quarter: `${quarter} ${year}`,
    northEast,
    southWest,
    limit: pageSize,
    page,
    isDownloadEnabled,
    coordinates,
    radius,
  };

  const response = await axiosMapInstance.post(
    `${demandBaseUrl}/final/${countryCode}${level ? "/" + level + "/" + levelVal : ""}`,
    requestBody,
    { cancelToken: cancelToken?.token, clearCacheEntry: true  }
  );
  return response.data;
};

export const getDemandOperatorGeohashes = async (
  {
    countryCode,
    level,
    levelVal,
    quarter,
    year,
    operator,
    northEast,
    southWest,
    ct,
    filter,
    dt,
    isDownloadEnabled,
    coordinates,
    radius,
  },
  cancelToken,
  pageSize,
  page
) => {
  const requestBody = {
    quarter: `${quarter} ${year}`,
    operator,
    northEast,
    southWest,
    connectionType: ct,
    dataType: dt,
    isDownloadEnabled,
    coordinates,
    filter,
    radius,
    limit: pageSize,
    page,
  };

  const response = await axiosMapInstance.post(
    `${demandBaseUrl}/operator/${countryCode}${
      level ? "/" + level + "/" + levelVal : ""
    }`,
    requestBody,
    { cancelToken: cancelToken?.token , clearCacheEntry: true,}
  );
  return response.data;
};

export const getDemandTooltipData = async (data) => {
  const response = await axiosMapInstance.get(
    `${demandBaseUrl}/tooltip/${data.countryCode}/${data.geohash}?quarter=${data.quarter}%20${data.year}`,
    { clearCacheEntry: true }
  );
  return response.data;
};

export const getCapacityGeohashes = async (query, bbox = false, cancelToken, pageSize, page) => {
  const requestBody = {
    ...query,
    bbox,
    page,
    pageSize,
    clearCacheEntry: !query.filterLvl ? bbox : undefined,
  };

  if (query?.advanceFilter?.length) {
    requestBody.advanceFilter = query.advanceFilter;
  }

  const response = await axiosMapInstance.post(
    `${capacityURL}/${query.countryCode}${query.level && query.levelVal ? "/" + query.level + "/" + query.levelVal : ""}`,
    requestBody,
    { cancelToken: cancelToken?.token, clearCacheEntry: true }
  );
  return response.data;
};


export const getCapacityTooltipData = async (data) => {
  let tooltipUrl =  getQueryParams(data, true)
  tooltipUrl = tooltipUrl.replace(/\?/, `/${data?.geohash}?`);
  const response = await axiosMapInstance.get(`${capacityURL}/tooltip/${tooltipUrl}`);
  return response.data;
};


